var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-chart (1) 1",
    clipPath: "url(#clip0_11877_18668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.026 15.6786V15.671H3.90354C2.82611 15.671 1.95254 14.8005 1.94801 13.723V1.34803C1.94801 0.810453 1.51161 0.374023 0.974004 0.374023C0.436395 0.374023 0 0.810418 0 1.34803V13.723C0 15.8786 1.7479 17.6266 3.90354 17.6266H17.026C17.5636 17.6266 18 17.1902 18 16.6526C18 16.115 17.5636 15.6786 17.026 15.6786Z",
    fill: "#475467"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Chart Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8482 4.48889C15.4163 4.16573 14.8047 4.2533 14.4816 4.6852L12.2164 7.93184L9.01511 5.52329C8.5855 5.20013 7.97466 5.28619 7.65151 5.71584C7.65073 5.71735 7.64999 5.71809 7.64848 5.7196L4.86242 9.72126C4.53701 10.1494 4.62083 10.7609 5.04892 11.0864C5.21275 11.211 5.41209 11.2804 5.61747 11.2842V11.3068C5.9157 11.2985 6.19431 11.1536 6.37252 10.9142L8.63764 7.66757L11.839 10.0761C12.2686 10.3993 12.8794 10.3132 13.2026 9.88358C13.2033 9.88207 13.2041 9.88133 13.2056 9.87981L16.0445 5.85548C16.3676 5.42362 16.28 4.81204 15.8482 4.48889Z",
    fill: "#475467"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11877_18668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/lineChart.42960e6cd3f7c4d2c991b3ef023e5f22.svg";
export { ForwardRef as ReactComponent };